import { Divider, Grid, Body, StackItem } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { TextKey } from '@mews-commander/enums';
import { DetailedUser } from '@mews-commander/data-access';
import { LocalizedLongDateFromUtc, LocalizedShortTimeFromUtc, LocalizedSmallParagraph } from '@mews-commander/ui';

const MetaDataItem = ({
    dateTimeString,
    labelTextKey,
}: {
    dateTimeString?: string | null;
    labelTextKey: Mews.TextKey;
}) => (
    <>
        <Grid columnGap="100" templateColumns="minmax(30%, min-content) 1fr" alignItems="center">
            <StackItem padding="200">
                <LocalizedSmallParagraph variant="secondary" textKey={labelTextKey} />
            </StackItem>
            <Body size="small">
                {dateTimeString ? (
                    <>
                        <LocalizedLongDateFromUtc utcString={dateTimeString} />
                        {UnicodeEntity.Space}
                        <LocalizedShortTimeFromUtc utcString={dateTimeString} />
                    </>
                ) : (
                    UnicodeEntity.Dash
                )}
            </Body>
        </Grid>
        <Divider />
    </>
);

export const ActivityMetaData = ({ user }: { user: DetailedUser }) => (
    <>
        <Divider />
        <MetaDataItem labelTextKey={TextKey.LastLogIn} dateTimeString={user.lastLogIn} />
        <MetaDataItem labelTextKey={TextKey.UpdatedOn} dateTimeString={user.updatedUtc} />
        <MetaDataItem labelTextKey={TextKey.CreatedOn} dateTimeString={user.createdUtc} />
    </>
);
